import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types/AppState";
import Component, { type SpacerComponentProps } from "./component";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: RootContainerProps): SpacerComponentProps => {
    return {
      style: styleSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
